module.exports = __webpack_public_path__ + "img/montaña.6b3808d1.svg";